import React from 'react';
import { ScoreBar } from './ScoreBar';

interface ScoreTileProps {
  title: string;
  score: number | null;
}

const toneLabel = (score: number | null) => {
  if (score == null) return 'Insufficient';
  if (score >= 75) return 'Strong';
  if (score >= 55) return 'Constructive';
  if (score >= 40) return 'Mixed';
  return 'Weak';
};

export const ScoreTile: React.FC<ScoreTileProps> = ({ title, score }) => (
  <div className="rounded-2xl border border-white/10 bg-[#171724] p-3 space-y-2">
    <div className="flex items-center justify-between">
      <p className="text-xs text-slate-400">{title}</p>
      <p className="text-sm font-semibold text-white">{score ?? '—'}</p>
    </div>
    <ScoreBar score={score} />
    <p className="text-[11px] text-slate-500">{toneLabel(score)}</p>
  </div>
);
